import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { BaseAPI } from '../../classes/BaseAPI'

import { CreatePresignedUrlRequest } from './types'

export class DocumentAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }

  generatePresignedUrl = async ({ fileName, fileType, objectType, objectId }: CreatePresignedUrlRequest): Promise<{ url: string }> => {
    return await this.request('/files/generate-presigned-url', 'POST', { fileName, fileType, objectType, objectId })
  }

  uploadDocumentToAwsS3 = async (url: string, document: File) => {
    const headers = {
      'Content-Type': document.type,
    }
    const requestConfig: AxiosRequestConfig = {
      url,
      method: 'PUT',
      headers,
      data: document,
    }
    const response = await Axios(requestConfig)
    return response.data
  }
}
